export const siteSettings = {
  name: "Universal Trade Market",
  link: "https://universaltrademarket.net",
  email: "support@universaltrademarket.net",
  appLink: "https://app.universaltrademarket.net",
};
